import React, { FC, useEffect, useState } from "react";
import { CustomSelect, Loader } from "src/components/ui";
import { periodOptions } from "../OverviewCard";
import { DashboardCard } from "../ui/DashboardCard";
import { AiInitiatedEmailChart, AiInitiatedEmailEmptyData, AiInitiatedEmailTable } from "./ui";
import "./index.less";
import { AppDispatch } from "src/store";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getPhoneGraphAnalytics } from "src/store/outreach-phones/asyncRequests";
import { outreachPhonesSelector } from "src/store/outreach-phones";
import { Button, Row } from "antd";
import { SvgIcon } from "src/shared/icons";
import { fullUserSelector } from "src/store/user";

export const AiInitiatedEmailCard = () => {
  const [periodOfTime, setPeriodOfTime] = useState("Last 7 days");

  const dispatch = useDispatch<AppDispatch>();
  const { graphLoading, phoneAnalyticsOverview } = useSelector(outreachPhonesSelector);
  const getAnalytics = (timeframe?: string) => {
    const tz = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
    dispatch(getPhoneGraphAnalytics({ timeframe: timeframe || periodOfTime, tz }));
  };

  const handleChangeTimeframe = (val) => {
    // console.log(val, "VALasvsdav");
    setPeriodOfTime(val);
    getAnalytics(val);
  };
  const headerRightContent = (
    <Row wrap={false} style={{ gap: 18 }}>
      <Button className="link" onClick={() => !graphLoading && getAnalytics()}>
        {graphLoading ? <Loader size={"small"} /> : <SvgIcon type={"refresh"} width={12} height={12} />}
        <div style={{ marginLeft: "5px" }}> Refresh</div>
      </Button>
      <CustomSelect
        isSearchSelect={false}
        options={periodOptions}
        value={periodOfTime}
        popupClassName={"dashboard-select-dropdown"}
        style={{ width: 130, height: 26 }}
        onSelect={handleChangeTimeframe}
      />
    </Row>
  );
  const isTeam = false;

  let { user } = useSelector(fullUserSelector);
  const isTest = user?.is_testing_mode_now;

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const daysArray = Array.from({ length: 30 }, (_, i) => ({
    start: moment()
      .tz(timezone)
      .subtract(29 - i, "days")
      .startOf("day")
      .unix(),
  }));

  const [analyticsData, setAnalyticsData] = useState([]);
  // generate nested 30-day calls data
  const analyticsDataCrt = () => {
    const an = daysArray.map((day) => {
      const m = moment.unix(day.start).tz(timezone);
      const date = m.format("DD MMM");
      const isWeekend = [6, 0].includes(m.day());

      const outgoing = isWeekend ? 0 : Math.floor(Math.random() * 71) + 30;
      const incoming = isWeekend ? 0 : Math.floor(Math.random() * (outgoing - Math.ceil(outgoing * 0.4) + 1)) + Math.ceil(outgoing * 0.4);
      const bad = isWeekend ? 0 : Math.floor(Math.random() * (Math.floor(incoming * 0.3) - Math.ceil(incoming * 0.1) + 1)) + Math.ceil(incoming * 0.1);
      const good = isWeekend ? 0 : incoming - bad;

      return [
        { date, type: "Outgoing calls", value: outgoing },
        { date, type: "Incoming Calls", value: incoming },
        { date, type: "Good Calls", value: good },
        { date, type: "Bad Calls", value: bad },
      ];
    });
    setAnalyticsData(an);
  };
  useEffect(() => {
    analyticsDataCrt();
  }, []);
  // choose period
  const sliceCount = periodOfTime === "Last 7 days" ? 7 : 30;

  // **take the last N days**, then flatten to one array of metric objects
  const chartData = analyticsData
    .slice(-sliceCount) // ← use negative index for most recent
    .flat();

  return (
    <DashboardCard customClassName={"ai-initiated-card-wrapper"} title={"Dialer Analytics Overview"} headerRightContent={headerRightContent}>
      {!!isTest || !!phoneAnalyticsOverview?.length ? (
        <>
          <AiInitiatedEmailChart data={isTest ? chartData : phoneAnalyticsOverview} />
        </>
      ) : (
        <AiInitiatedEmailEmptyData />
      )}
      {isTeam ? <AiInitiatedEmailTable /> : ""}
    </DashboardCard>
  );
};
